import { SegmentedControl, SegmentedControlProps, rem } from '@mantine/core';
import cn from 'clsx';
import { Select } from 'src/components/Select/Select';

const maxWidthValues = ['sm', 'md', 'lg', '1100'] as const;
const maxWidthClasses = {
  sm: {
    buttons: 'max-sm:hidden',
    select: 'sm:hidden',
  },
  md: {
    buttons: 'max-md:hidden',
    select: 'md:hidden',
  },
  lg: {
    buttons: 'max-lg:hidden',
    select: 'lg:hidden',
  },
  1100: {
    buttons: 'max-[1100px]:hidden',
    select: 'min-[1100px]:hidden',
  },
};

export function FilterButtons({
  data,
  value,
  selectMaxW = maxWidthValues[0],
  onChange,
  segControlProps,
}: {
  data: SegmentedControlProps['data'];
  value: SegmentedControlProps['value'];
  selectMaxW?: (typeof maxWidthValues)[number];
  onChange: SegmentedControlProps['onChange'];
  segControlProps?: Partial<SegmentedControlProps>;
}) {
  if (data.length <= 1) {
    return null;
  }

  return (
    <>
      <SegmentedControl
        withItemsBorders={false}
        {...segControlProps}
        data={data}
        value={value}
        onChange={onChange}
        styles={{
          root: {
            outline: 'none',
            background: 'transparent',
            gap: 8,
            height: rem(34),
            overflow: 'visible',
            flexShrink: 0,
          },
          indicator: { display: 'none' },
        }}
        className={cn(maxWidthClasses[selectMaxW].buttons)}
        classNames={{
          label: cn(
            'px-4 rounded-[48px] text-[14px] !leading-[34px] font-[600]',
            'text-[#7B7B7B] bg-[rgba(16,16,16,0.40)] transition-colors',
            'outline-[1px] outline outline-[#1d1e20]',
            'data-[active]:text-[#fff] data-[active]:outline-primarybrand hover:text-[#fff]'
          ),
        }}
      />

      <Select
        options={data.map((o) =>
          typeof o === 'string'
            ? { label: o, value: o }
            : { label: o.label as string, value: o.value }
        )}
        value={value}
        stackProps={{
          className: cn(maxWidthClasses[selectMaxW].select),
        }}
        onChange={(newValue) => onChange?.(newValue)}
      />
    </>
  );
}
